(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shipping-progress"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.thegesShippingProgressInitialized) return;
  window.thegesShippingProgressInitialized = true;

  const money = new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR'
  });

  const renderMessage = (element) => {
    const subtotal = Number(element.dataset.cartSubtotal || 0);
    const region = element.dataset.initialRegion || 'other';
    const isBanner = element.dataset.shippingVariant === 'banner';
    const message = element.querySelector('[data-shipping-message]');

    if (!message) return;

    const setMessage = (panelText, bannerText = panelText) => {
      message.textContent = isBanner ? bannerText : panelText;
    };

    if (region !== 'peninsula' && region !== 'canarias') {
      setMessage(
        'El envío se calculará automáticamente según tu ubicación en el checkout.',
        '🚚 Envío calculado según tu ubicación'
      );
      return;
    }

    if (region === 'peninsula') {
      const threshold = 2500;

      if (subtotal >= threshold) {
        setMessage(
          'Ya tienes envío estándar gratis.',
          '🚚 Ya tienes envío estándar gratis.'
        );
      } else {
        const remaining = money.format((threshold - subtotal) / 100);

        setMessage(
          `Te faltan ${remaining} para conseguir envío estándar gratis.`,
          `🚚 Añade ${remaining} para conseguir envío estándar gratis.`
        );
      }

      return;
    }

    if (region === 'canarias') {
      if (subtotal < 6000) {
        setMessage(
          `El envío cuesta 31,95 €. Añade ${money.format((6000 - subtotal) / 100)} para reducirlo a 14,95 €.`,
          `🚚 Añade ${money.format((6000 - subtotal) / 100)} y el envío baja a 14,95 €`
        );
        return;
      }

      if (subtotal < 8999) {
        setMessage(
          `Tu envío cuesta 14,95 €. Te faltan ${money.format((8999 - subtotal) / 100)} para conseguir envío gratis.`,
          `🚚 Añade ${money.format((8999 - subtotal) / 100)} para conseguir envío gratis`
        );
        return;
      }

      setMessage(
        'Ya tienes envío gratis.',
        '🚚 Ya tienes envío gratis'
      );
    }
  };

  const renderAll = () => {
    document
      .querySelectorAll('[data-shipping-progress]')
      .forEach((element) => renderMessage(element));
  };

  if (
    typeof subscribe === 'function' &&
    typeof PUB_SUB_EVENTS !== 'undefined'
  ) {
    subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        const subtotal = Number(event?.cartData?.items_subtotal_price);

        if (!Number.isFinite(subtotal)) return;

        document
          .querySelectorAll('[data-shipping-progress]')
          .forEach((element) => {
            element.dataset.cartSubtotal = String(subtotal);
          });

        renderAll();
      }
    );
  }

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;

        if (node.matches('[data-shipping-progress]')) {
          renderMessage(node);
        }

        node
          .querySelectorAll?.('[data-shipping-progress]')
          .forEach((element) => renderMessage(element));
      });
    });
  }).observe(document.body, {
    childList: true,
    subtree: true
  });

  renderAll();
})();
  } catch(e) { console.error(e); }
})();

})();
